<template>
  <div class="linfocitos-barras-apiladas" :id="barras_apiladas_id">
    <h3 class="m-0">Distribución del conteo de linfocitos T CD4+</h3>
    <svg class="svg-barras-apiladas">
      <defs></defs>
      <g class="grupo-contenedor-de-barras"></g>
    </svg>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "Linfocitos",

  props: {
    data_store: String,
    alto_vis: Number,
    barras_apiladas_id: String,
    datos: Array,
    titulo: String,
    instruccional: String,
    titulo_leyenda: String,
    enlace_proyecto: String,
    titulo_proyecto: String,
    fecha_actualizacion: String,
    texto_fuente: String,
    texto_notas: String,
    link_descarga_csv: String,
    nombre_variables: Object,
    titulo_eje_x: String,
    titulo_eje_x2: String,
    titulo_eje_y: String,
    notas: {
      type: String,
    },
    columnas_descargables: {
      type: Array,
      default: function () {
        return ["nombre", "cantidad_1", "cantidad_2"];
      },
    },
    titulo_tooltip: {
      type: String,
      default: "",
    },
    ancho_tooltip: {
      type: Number,
      default: 165,
    },

    margen: {
      type: Object,
      default: function () {
        return { arriba: 3, abajo: 3, izquierda: 65, derecha: 22 };
      },
    },

    variables: {
      type: Array,
    },
  },

  watch: {
    variables: function (nuevo_valor) {
      this.variables = nuevo_valor;
      this.barras_apiladas.style("fill", (d, i) => this.variables[i].color);
    },
    datos: function (new_val, old_val) {
      this.datos = new_val;
      this.configurandoDimensionesParaBarras();
      if (new_val.length > old_val.length) {
        //Actualizamos paths
        this.barras_apiladas = this.grupo_contenedor
          .selectAll("g.grupos-barras")
          .data(this.data_apilada);
        this.barras_apiladas = this.barras_apiladas
          .enter()
          .append("g")
          .style("cursor", "pointer")
          .merge(this.barras_apiladas);
        this.barras_apiladas.exit().remove();
      } else {
        this.barras_apiladas.data(this.data_apilada).exit().remove();
      }
      this.barras_apiladas
        .attr("class", (d) => d.key + " grupos-barras")
        .style("fill", (d, i) => this.variables[i].color);

      this.barras_individuales.remove();
      this.barras_individuales = this.barras_apiladas
        .selectAll("rect")
        .data((d) => d)
        .enter()
        .append("rect");

      //Ajustes
      this.actualizandoBarras();
    },
  },

  data: function () {
    return {
      notas_open: false,
      orden_inicial: true,
      zoom_activo: "hidden",
      width: 200,
    };
  },
  mounted: function () {
    this.svg = d3.select("#" + this.barras_apiladas_id + " svg.svg-barras-apiladas");

    this.grupo_contenedor = this.svg.select("g.grupo-contenedor-de-barras");

    this.eje_y = this.grupo_contenedor.append("g").attr("class", "eje-y");
    this.eje_x = this.grupo_contenedor.append("g").attr("class", "eje-x");

    this.texto_x = this.grupo_contenedor.append("text").text(this.titulo_eje_x);
    this.texto_x2 = this.grupo_contenedor.append("text").text(this.titulo_eje_x2);
    this.texto_y = this.grupo_contenedor.append("text").text(this.titulo_eje_y);

    this.configurandoDimensionesParaSVG();
    this.configurandoDimensionesParaBarras();
    this.creandoBarras();
    this.actualizandoBarras();

    this.tooltip = d3.select("#" + this.barras_apiladas_id).select("div.tooltip");
    window.addEventListener("resize", this.reescalandoPantalla);
  },
  beforeDestroy() {
    window.addEventListener("resize", this.reescalandoPantalla);
  },
  methods: {
    configurandoDimensionesParaSVG: function () {
      // el calculo del ancho en caso de estar cerrado/colapsado la grafica, va a tomar 0 tons el valor se setea a 200
      // siempre tomar en cuenta el menor lugar en el que este contando margenes y paddings
      // console.log('id client width')
      // console.log(document.getElementById(this.barras_apiladas_id).clientWidth);
      this.width =
        (document.getElementById(this.barras_apiladas_id)?.clientWidth
          ? document.getElementById(this.barras_apiladas_id).clientWidth
          : 200) -
        this.margen.izquierda -
        this.margen.derecha;
      this.height = this.alto_vis - this.margen.arriba - this.margen.abajo;
      this.svg
        .attr("width", this.width + this.margen.izquierda + this.margen.derecha)
        .attr("height", this.height + this.margen.arriba + this.margen.abajo);

      this.grupo_contenedor.attr(
        "transform",
        `translate(${this.margen.izquierda},${this.margen.arriba})`
      );
      this.texto_x
        .attr("x", this.width * 0.5)
        .attr("y", this.height + 20)
        // this.texto_x.attr("x",this.width/2).attr("y",this.height + 25)
        .style("text-anchor", "middle")
        .style("font-size", "10px")
        .style("dominant-baseline", "hanging")
        .style("font-weight", "bolder");
      this.grupo_contenedor.attr(
        "transform",
        `translate(${this.margen.izquierda},${this.margen.arriba})`
      );
      this.texto_x2
        .attr("x", this.width * 0.5)
        .attr("y", this.height + 30)
        // this.texto_x.attr("x",this.width/2).attr("y",this.height + 25)
        .style("text-anchor", "middle")
        .style("font-size", "10px")
        .style("dominant-baseline", "hanging")
        .style("font-weight", "bolder");

      this.texto_y
        .attr("x", -(this.height / 2))
        .attr("y", -35)
        .attr("transform", "rotate(-90)")
        .style("text-anchor", "middle")
        .style("font-size", "10px")
        .style("dominant-baseline", "hanging")
        .style("font-weight", "bolder");
      const extent = [
        [this.margen.izquierda, this.margen.arriba],
        [this.width, this.height],
      ];
    },
    configurandoDimensionesParaBarras: function () {
      this.data_apilada = d3.stack().keys(this.variables.map((d) => d.id))(this.datos);

      for (let i = 0; i < this.variables.length; i++) {
        this.data_apilada[i].forEach(
          (dd) => (dd.data = Object.assign({}, dd.data, { key: this.data_apilada[i].key }))
        );
      }
      this.escalaY = d3
        .scaleLinear()
        .domain([0, d3.max(this.datos.map((d) => d3.sum(this.variables.map((dd) => d[dd.id]))))])
        .range([this.height, 0]);
      this.escalaX = d3
        .scaleLinear()
        .domain([0, d3.max(this.datos.map((d) => d.rango[1]))])
        .range([0, this.width]);

      this.eje_x
        .attr("transform", `translate(0,${this.height})`)
        .call(d3.axisBottom(this.escalaX).ticks(5));

      this.eje_y.call(d3.axisLeft(this.escalaY).ticks(5));
      this.eje_y.select("path.domain").attr("d", function () {
        return d3.select(this).attr("d").replace("M-6", "M 0").replace("H-6", "H0");
      });
    },
    creandoBarras: function () {
      this.barras_apiladas = this.grupo_contenedor
        .selectAll("grects")
        .data(this.data_apilada)
        .enter()
        .append("g")
        .attr("class", (d) => d.key + " grupos-barras")
        .style("fill", (d, i) => this.variables[i].color);
      this.barras_individuales = this.barras_apiladas
        .selectAll("rect")
        .data((d) => d)
        .enter()
        .append("rect");
    },

    actualizandoBarras: function () {
      this.barras_individuales

        .attr("y", (d) => this.escalaY(d[1]))
        .attr("x", (d) => this.escalaX(d.data.rango[0]))

        .attr("width", (d) => this.escalaX(d.data.rango[1] - 3) - this.escalaX(d.data.rango[0]))
        .attr("height", (d) => this.escalaY(d[0]) - this.escalaY(d[1]));
      this.eje_y.select("path").style("opacity", 0);
      this.eje_y
        .selectAll("line")
        .style("stroke-dasharray", "3,3")
        .style("stroke", "#707070CC")
        .attr("x2", this.width);
      this.eje_y.selectAll("text").style("font-weight", "400").attr("x", "-4");
    },

    reescalandoPantalla: function () {
      this.configurandoDimensionesParaSVG();
      this.configurandoDimensionesParaBarras();
      this.actualizandoBarras();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.linfocitos-barras-apiladas {
  font-family: "Montserrat";
  position: relative;
  width: 100%;
}
svg.svg-barras-apiladas {
  margin-top: 10px;
}
svg.svg-barras-apiladas::v-deep text {
  font-family: "Montserrat";
}
</style>
